"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Checkbox = _interopRequireDefault(require("../checkbox/Checkbox"));

var TreeNode = /*#__PURE__*/_react.default.memo(function (props) {
  var node = props.node,
      hasMultiselect = props.hasMultiselect,
      isSelected = props.isSelected,
      isIndeterminate = props.isIndeterminate,
      onToggleNode = props.onToggleNode,
      onSelect = props.onSelect;
  var treeNodeClassNames = (0, _classnames.default)('TreeNode', 'from-group', isSelected && 'checked', node.className && node.className);
  var hasChildren = !!node.items.length;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: treeNodeClassNames,
    "data-key": node.id,
    onClick: function onClick() {
      return hasChildren && onToggleNode(node.id);
    }
  }, hasMultiselect && /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    className: 'TreeCheckbox',
    checked: isSelected,
    disabled: node.disabled,
    indeterminate: isIndeterminate,
    onClick: function onClick() {
      return onSelect(node, isIndeterminate);
    }
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: 'TreeLabel'
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'TreeLabelName'
  }, node.icon && /*#__PURE__*/_react.default.createElement("span", {
    className: "rioglyph ".concat(node.icon)
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: 'TreeLabelNameText'
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'TreeLabelNameTextHeadline'
  }, node.name)), /*#__PURE__*/_react.default.createElement("span", {
    className: 'TreeLabelCount label label-muted label-filled label-condensed'
  }, node.items.length)), /*#__PURE__*/_react.default.createElement("span", {
    className: "TreeLabelExpander rioglyph rioglyph-chevron-down ".concat(hasChildren ? '' : 'text-color-light')
  })));
});

TreeNode.displayName = 'TreeNode';
TreeNode.defaultProps = {
  isSelected: false,
  isIndeterminate: false,
  hasMultiselect: true
};
TreeNode.propTypes = {
  node: _propTypes.default.object,
  hasMultiselect: _propTypes.default.bool,
  isSelected: _propTypes.default.bool,
  isIndeterminate: _propTypes.default.bool,
  onToggleNode: _propTypes.default.func,
  onSelect: _propTypes.default.func,
  className: _propTypes.default.string
};
var _default = TreeNode;
exports.default = _default;